var map = {
	".": 336,
	"./": 336,
	"./Component": 1055,
	"./Component.js": 1055,
	"./OldUi": 1056,
	"./OldUi.js": 1056,
	"./RenderComponent": 766,
	"./RenderComponent.js": 766,
	"./TopActions": 765,
	"./TopActions.js": 765,
	"./index": 336,
	"./index.js": 336,
	"./style": 431,
	"./style.js": 431
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 4212;
module.exports = webpackAsyncContext;